export default {
  name: "setting-correspondence"
};